import React from 'react';
import './index.less';

export const Loading = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <div
      className={'page-loading'}
      style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--Fill_Background)',
        flexDirection: 'column',
        ...style,
      }}
    >
      <img
        style={{ marginBottom: '20px', width: 60, height: 60 }}
        src="https://img.alicdn.com/imgextra/i4/O1CN01wHjZ7c1j5DndMJFyd_!!6000000004496-54-tps-512-512.apng"
        alt="全局加载中"
      />
    </div>
  );
};
